<template>
  <div class="upload-wrap">
    <Upload :disabled="disabled" action="/" :before-upload="handleUpload" class="videoBoxContent" :show-upload-list="false">
      <div v-if="fileType == '.pdf'">
        <div v-if="!videoUrl && !isUpload">
          <span class="btn">{{ btnVal || '上传视频' }}</span>
        </div>
        <div v-if="isUpload || videoUrl" class="upload-box">
          <img class="icon-del" @click.stop="del" src="@static/images/operate/close.png" alt="" />
          <div class="flex">
            <div v-if="fileType.indexOf('pdf') != -1" class="icon-type">
              <div class="eyes">
                <Icon v-if="!isUpload" type="ios-eye-outline" @click.native="handleView(videoUrl)"> </Icon>
              </div>
            </div>
            <div>
              <p class="name">{{ file.name }}</p>
              <p class="size">{{ file.sizeStr }}</p>
            </div>
          </div>
          <Progress :stroke-width="3" :percent="progress" hide-info></Progress>
        </div>
        <!-- <video v-if="videoUrl" controls="controls" width="400" :src="videoUrl" autoplay></video> -->
      </div>
      <template v-else-if="fileType == '.mp4'">
        <div v-if="!videoUrl && !isUpload">
          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
        </div>
        <div v-if="isUpload || videoUrl" class="video-wrap" @click.stop>
          <Spin fix v-if="isUpload">
            <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
            <div>{{ progress }}%</div>
          </Spin>
          <div class="video-mask" v-if="!videoUrl"></div>
          <videoPlayer :src="videoUrl" ref="video"></videoPlayer>

          <!-- <video :src="videoUrl" controls controlslist="nodownload" x5-playsinline playsinline
						webkit-playsinline x-webkit-airplay ref="video"></video> -->
          <Icon v-if="!isUpload && !disabled" class="icon-close" type="ios-close-circle" @click.stop="del" />
        </div>
      </template>
    </Upload>
    <span class="tip loading" v-if="isUpload && fileType != '.mp4'">正在上传...</span>
  </div>
</template>

<script>
import videoPlayer from '@/components/commons/videoPlayer';
import { uploadVideoFile, uploadOssVideoFile, uploadFile } from '@/api/httpList';
export default {
  props: {
    url: [String, Object],
    fileType: {
      type: String,
      default: ''
    },
    btnVal: {
      type: String,
      default: '上传视频'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: { videoPlayer },
  data() {
    return {
      file: {},
      isUpload: false,
      progress: 0,
      videoUrl: '',
      imgUrl: ''
    };
  },
  watch: {
    url: {
      handler(newVal) {
        if (this.fileType == '.pdf') {
          if (newVal.url == this.videoUrl) return;
          if (!newVal.url) {
            this.file = {};
            this.videoUrl = '';
          } else {
            this.videoUrl = newVal.url;
            this.file.name = newVal.fileName;
            this.file.sizeStr = newVal.sizeStr;
            this.progress = 100;
          }
        } else {
          if (newVal == this.videoUrl) return;
          if (!newVal || !newVal.url) {
            this.file = {};
            this.videoUrl = '';
          } else {
            this.videoUrl = newVal;
            this.file.name = newVal.split('/').pop();
            this.file.type = newVal.split('.').pop();
            this.progress = 100;
          }
        }
      },
      immediate: true, //刷新加载 立马触发一次handler
      deep: true // 可以深度检测到 person 对象的属性值的变化
    }
  },
  mounted() {
    if (this.url) {
      if (this.fileType == '.pdf') {
        this.videoUrl = this.url.url;
        this.file.name = this.url.fileName;
        this.file.sizeStr = this.url.sizeStr;
      } else {
        this.videoUrl = this.url;
        this.file.name = this.url.split('/').pop();
        this.file.type = this.url.split('.').pop();
      }
      this.progress = 100;
    } else {
      this.file = {};
      this.videoUrl = '';
    }
  },
  methods: {
    del() {
      this.file = {};
      this.videoUrl = '';
      if (this.fileType == '.mp4') {
        this.$emit('upload', {
          url: '',
          second: ''
        });
      } else if (this.fileType == '.pdf') {
        this.$emit('upload', {
          url: '',
          sizeStr: ''
        });
      }
    },
    uploadVideo(formData) {
      uploadOssVideoFile(formData, e => {
        //文件上传进度条
        if (e.lengthComputable) {
          this.uploadRate = e.loaded / e.total; //已上传的比例
          if (this.uploadRate < 1) {
            //这里的进度只能表明文件已经上传到后台，但是后台有没有处理完还不知道
            //因此不能直接显示为100%，不然用户会误以为已经上传完毕，关掉浏览器的话就可能导致上传失败
            //等响应回来时，再将进度设为100%
            this.progress = +(this.uploadRate * 100).toFixed(0);
          }
        }
      })
        .then(async res => {
          let second = await this.FileValue(res.data.videoUrl)
          this.videoUrl = res.data.videoUrl;
          this.imgUrl = res.data.videoCover;
          this.progress = 100;
          this.isUpload = false;
          this.playing = false;
          this.$emit('upload', {
            url: this.videoUrl,
            imgUrl: this.imgUrl,
            size: this.file.size,
            second: second
          });
        })
        .catch(e => {
          this.$notice.success('上传失败');
          this.videoUrl = null;
          this.file = {};
          this.progress = 0;
          this.isUpload = false;
          this.playing = false;
        });
    },
    uploadFileFn(formData, file) {
      uploadFile(formData, e => {
        //文件上传进度条
        if (e.lengthComputable) {
          this.uploadRate = e.loaded / e.total; //已上传的比例
          if (this.uploadRate < 1) {
            //这里的进度只能表明文件已经上传到后台，但是后台有没有处理完还不知道
            //因此不能直接显示为100%，不然用户会误以为已经上传完毕，关掉浏览器的话就可能导致上传失败
            //等响应回来时，再将进度设为100%
            this.progress = +(this.uploadRate * 100).toFixed(0);
          }
        }
      })
        .then(res => {
          this.videoUrl = res.data[0].path;
          this.progress = 100;
          this.isUpload = false;
          this.$emit('upload', {
            url: this.videoUrl,
            sizeStr: file.sizeStr,
            fileName: file.name
          });
        })
        .catch(e => {
          this.$notice.success('上传失败');
          this.videoUrl = null;
          this.file = {};
          this.progress = 0;
          this.isUpload = false;
        });
    },
    //获取视频时长
    FileValue(url) {
      //视频地址
      return new Promise(resolve => {
        var video = new Audio(url);
        var duration = 0;
        video.addEventListener('loadedmetadata', function (e) {
          duration = video.duration;
          console.log('视频时长为', duration);
          resolve(duration);
        });
      });
    },

    handleUpload(file) {
      console.log(file);
      if (file.size) {
        file.sizeStr = file.size / 1024 > 1024 ? (file.size / 1024 / 1024).toFixed(1) + 'M' : (file.size / 1024).toFixed(1) + 'KB';
      }
      this.file = file;
      this.videoUrl = '';
      this.progress = 0;
      let reg = '';
      let msg = '';
      if (this.fileType == '.mp4') {
        reg = /\.(mp4)$/;
        msg = '上传格式不正确，请上传视频格式';
      } else if (this.fileType == '.pdf') {
        reg = /\.(pdf)$/;
        msg = '上传格式不正确，请上传PDF文件';
      }
      if (!reg.test(file.name.toLowerCase())) {
        this.$Message.error(msg);
        return false;
      }
      this.isUpload = true;
      let formData = new FormData();
      formData.append('file', file);
      var res = '';
      if (this.fileType == '.mp4') {
        this.uploadVideo(formData);
      } else {
        this.uploadFileFn(formData, file);
      }
      return false;
    },
    handleView(url) {
      window.open(url);
    }
  }
};
</script>

<style scoped lang="scss">
.upload-wrap {
  margin: 0 auto;
  display: flex;
  align-items: flex-end;
  line-height: 1;
  width: 100%;
  height: 100%;

  // height: 80px;
  .btn {
    padding: 0 16px;
    display: inline-block;
    min-width: 88px;
    height: 32px;
    background: #f5f8ff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #eaf2ff;
    font-size: 14px;
    color: #236dff;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
  }
  .videoBoxContent {
    width: 100%;
    height: 100%;
  }
  /deep/ .ivu-upload {
    width: 100%;
    height: 100%;
  }
  .upload-box {
    width: 260px;
    height: 80px;
    background: #fafafa;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #e3e5e8;
    position: relative;
    padding-top: 15px;

    .flex {
      display: flex;
      align-items: center;
    }

    .icon-type {
      width: 43px;
      height: 43px;
      background: #ffffff;
      margin: 0 6px 0 10px;
      cursor: pointer;
      background: url('~@static/images/cc_pdf_new.png') no-repeat;
      background-size: 43px;
      position: relative;

      .eyes {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        line-height: 43px;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;

        .ivu-icon {
          color: #fff;
          font-size: 18px;
          cursor: pointer;
        }
      }

      &:hover {
        .eyes {
          display: block;
        }
      }
    }

    .icon-del {
      position: absolute;
      cursor: pointer;
      width: 10px;
      height: 10px;
      top: 6px;
      right: 6px;
    }

    .name {
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      width: 169px;
      white-space: nowrap;
      font-size: 14px;
      color: #515c6f;
      line-height: 20px;
    }

    .size {
      display: block;
      font-size: 12px;
      color: #a8adb7;
      margin-top: 4px;
      line-height: 17px;
    }

    /deep/.ivu-progress {
      width: calc(100% - 25px);
      margin-left: 10px;
      line-height: 1;
    }

    /deep/.ivu-progress-success .ivu-progress-bg {
      background-color: #236dff;
    }
  }

  .tip {
    white-space: nowrap;
    font-size: 12px;
    margin-left: 10px;
  }

  .loading {
    color: #236dff;
  }

  .video-wrap {
    position: relative;
    width: 100%;
    height: 100%;

    /deep/ .vue-video-player,
    video {
      max-width: 100%;
      max-height: 300px;
    }
    .video-mask {
      width: 100%;
      min-height: 150px;
      background: rgba(0, 0, 0, 0.3);
      &.absolute {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        min-height: auto;
        cursor: pointer;
      }
    }

    .icon-close {
      font-size: 20px;
      position: absolute;
      top: -10px;
      right: -10px;
      cursor: pointer;
      opacity: 0.6;
    }
  }
}
</style>
